<template lang="pug">
w-input.f-string(
  v-bind=`{ value, label, required }`
  ref='input'
  @input='input'
)
</template>

<script lang="js">
import WInput, { mixin } from '@/widgets/w-input'

export default {
  name: 'StringField',
  mixins: [ mixin ],
  components: { WInput },
  props: {
    label: {
      type: String,
      default: 'String'
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.f-string {

}
</style>
